export const splitDuration = (duration) => {
  const durationSeconds = duration / 1000;

  return {
    minutes: Math.floor(durationSeconds / 60),
    seconds: Math.floor(durationSeconds % 60),
  };
};

export const formatSplitDuration = (duration) => {
  const { minutes, seconds } = splitDuration(duration);

  return {
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  }
};

export const formatDuration = (duration) => {
  const { minutes, seconds } = formatSplitDuration(duration);

  return `${minutes}:${seconds}`;
};